module.exports = __webpack_public_path__ + "static/media/work-img1.5f86d882.jpg";